import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {mobileSidebarToggle} from "../../../_reducers/MobileSidebar";
import {activePath} from "../../../_reducers/Navbar";
import {
    checkPermission,
    checkPermissionMasterParentStartingTree, getCurrentUser
} from "../../../_helpers/commonFunctions";
import {handleLogOut} from "../../../_apis/api";
import {Dropdown, DropdownButton} from "react-bootstrap";
import useMediaQuery from "../../../hooks/useMediaQuery";
import {setShowReleaseNotesModal, setSlideBarOpen, setSlideBarToggle} from "../../../_reducers/activitySlice";
import {
    openPrescriptionHome,
    openPrescriptionSettings,
    openStart, openTabByType,
    openUserSettings
} from "../../../_helpers/tabOpeners";
import {IoIosArrowDown} from "react-icons/io";
import {useTranslation} from "../../../hooks/useTranslation";

const Navbar = ({permissionsData}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const currentUser = getCurrentUser();
    const isMobileScreen = useMediaQuery("(max-width: 980px)");
    const isMediumScreen = useMediaQuery("(max-width: 1280px)");
    const isEmployee = permissionsData?.find((el) => el.permissionName === "custom-employee");
    const isCompanyCreator = permissionsData?.find((el) => el.permissionName === "custom-companyCreator");
    const isAdmin = currentUser?.userType === "Admin";
    const companyHasPrescription = useSelector((state) => state.PRESCRIPTION.companyHasPrescription);
    const isEmronConnectFileERP = useSelector((state) => state.ACTIVITY.isEmronConnectFileERP);
    const slideBarOpen = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarOpen);
    const slideBarToggle = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarToggle);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);

    const handleClick = (e) => {
        if (e === "Start") dispatch(openStart(TABS_DATA));

        dispatch(activePath(e === "Start" ? "" : e));
        dispatch(mobileSidebarToggle());
        if (!isMobileScreen) {
            if (slideBarToggle) {
                dispatch(setSlideBarToggle(false));
                dispatch(setSlideBarOpen(true));
            }
        }
        if (e === "Prescription") {
            if (!companyHasPrescription) {
                dispatch(openPrescriptionSettings(TABS_DATA));
            } else {
                if (TABS_DATA?.length <= 1) {
                    dispatch(openPrescriptionHome(TABS_DATA));
                }
            }
        }
    }

    const handleOpenUserManagement = () => {
        dispatch(openUserSettings(TABS_DATA));
    }

    const handleOpenManageCompanies = () => {
        dispatch(openTabByType('manage-companies', TABS_DATA));
    }

    const handleBurgerMenu = () => {
        dispatch(setSlideBarToggle(!slideBarToggle));
        dispatch(setSlideBarOpen(!slideBarOpen));
    }

    const renderNavItem = (navigationCategory) => {
        const lowerCase = String(navigationCategory).toLowerCase();
        return (
            <a
                onClick={() => handleClick(navigationCategory)}
                className={`nav-link ${navigationCategory === "Start" ? "active" : ""}`}
                data-toggle="pill"
                href={`#pills-${navigationCategory}`}
                style={{...isMediumScreen ? {fontSize: "11px"} : {}}}
            >
                <img
                    src={`assets/images/side-menu/${navigationCategory}-white.png`}
                    className={`img-fluid image-hover image-menu-hover`}
                    style={{width: "22px", marginLeft: "auto", marginRight: "auto" }}
                    alt={`${navigationCategory}`}
                />
                <img
                    src={`assets/images/side-menu/${navigationCategory}-dark.png`}
                    className="img-fluid image-without-hover"
                    style={{
                        width: "22px",
                        float: "none",
                        justifySelf: "center",
                        marginLeft: "auto",
                        marginRight: "auto"
                    }}
                    alt={`${navigationCategory}1`}
                />
                {t(`NavBar.${lowerCase}`)}
            </a>
        )
    }

    return (
        <div className={`navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row mainNavbar menu-is-hovered`} style={{pointerEvents: isEmronConnectFileERP ? "none" : ""}}>
            {/* ___________________________LOGO____________________________ */}
            <div className="text-center navbar-brand-wrapper d-flex justify-content-between align-items-center"
                 style={{ width: isMobileScreen ? "100%" : slideBarToggle ? "50px" : "", height: "70px"}}>
                {!isEmployee && (
                    <button
                        onClick={() => dispatch(mobileSidebarToggle())}
                        className="navbar-toggler navbar-toggler-left toggleSidebarBtn outline-danger"
                        type="button"
                        data-toggle="offcanvas"
                        hidden={!isMobileScreen}
                    >
                        <span className="mdi mdi-menu"></span>
                    </button>
                )}
                <div style={{cursor: "pointer", maxHeight: "70px"}} className="p-2 mx-auto">
                    <img
                        alt="Primer Logo"
                        className={"logo-transition"}
                        style={{
                            maxHeight: "40px",
                        }}
                        src={slideBarToggle ? "assets/images/primer-logo-mini.png" : "assets/images/prrimer-logo.png"}
                    />
                </div>
                {isMobileScreen && (
                    <div className={"mr-1"}>
                        <DropdownButton id="dropdown-basic-button" style={{padding: "4px"}} title={
                            <img
                                src={currentUser?.avatar ? currentUser?.avatar : "assets/images/faces/face16.jpg"}
                                alt="userAvatar"
                                style={{maxHeight: "30px", borderRadius: "50%"}}
                            />
                        }>
                            <Dropdown.Item onClick={() => handleOpenUserManagement()} className={"pt-1 pb-1"}>Ρυθμίσεις Χρήστη</Dropdown.Item>
                            {isAdmin && (<Dropdown.Item onClick={() => dispatch(setShowReleaseNotesModal(true))} className={"pt-1 pb-1"}>Release Notes</Dropdown.Item>)}
                            {(isAdmin || isCompanyCreator) && (<Dropdown.Item onClick={() => handleOpenManageCompanies()} className={"pt-1 pb-1"}>Διαχείρηση Εταιρειών</Dropdown.Item>)}
                            <Dropdown.Item onClick={() => dispatch(handleLogOut())} className={"pt-1 pb-1"}>Αποσύνδεση</Dropdown.Item>
                        </DropdownButton>
                    </div>
                )}
            </div>

            {!isMobileScreen && (
                <React.Fragment>
                    {/* _______________________NAVBAR MENU_____________________*/}
                    <div className="navbar-menu-wrapper d-flex" style={{width: slideBarToggle ? "calc(100% - 50px)" : "", height: "70px"}}>
                        <div className="navbar-burger" onClick={() => handleBurgerMenu()}>
                            <svg fill="#76aeb7" height="24px" width="24px" viewBox="0 0 230 230" stroke="#76aeb7">
                                <g strokeWidth="0"/>
                                <g strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M95,70h120c8.284,0,15-6.716,15-15s-6.716-15-15-15H95c-8.284,0-15,6.716-15,15S86.716,70,95,70z"/>
                                <path id="XMLID_106_" d="M215,100H95c-8.284,0-15,6.716-15,15s6.716,15,15,15h120c8.284,0,15-6.716,15-15S223.284,100,215,100z"/> <path d="M215,160H95c-8.284,0-15,6.716-15,15s6.716,15,15,15h120c8.284,0,15-6.716,15-15S223.284,160,215,160z"/> <path id="XMLID_108_" d="M15,160c-3.95,0-7.811,1.6-10.61,4.39C1.6,167.19,0,171.05,0,175c0,3.95,1.6,7.81,4.39,10.61 C7.189,188.4,11.05,190,15,190s7.81-1.6,10.609-4.39C28.399,182.81,30,178.95,30,175c0-3.95-1.601-7.81-4.391-10.61 C22.81,161.6,18.95,160,15,160z"/>
                                <path id="XMLID_109_" d="M15,100c-3.95,0-7.811,1.6-10.61,4.39C1.6,107.19,0,111.05,0,115c0,3.95,1.6,7.81,4.39,10.61 C7.189,128.4,11.05,130,15,130s7.81-1.6,10.609-4.39C28.399,122.81,30,118.95,30,115c0-3.95-1.601-7.81-4.391-10.61 C22.81,101.6,18.95,100,15,100z"/> <path id="XMLID_110_" d="M15,40c-3.95,0-7.811,1.6-10.61,4.39C1.6,47.19,0,51.05,0,55c0,3.95,1.6,7.81,4.39,10.61 C7.189,68.4,11.05,70,15,70s7.81-1.6,10.609-4.39C28.399,62.81,30,58.95,30,55c0-3.95-1.601-7.81-4.391-10.61 C22.81,41.6,18.95,40,15,40z"/>
                            </svg>
                        </div>
                        {/* __________________NAV LINKS_________________ */}
                        <div className="align-self-center mx-auto">
                            <div className="center-navbar-menu">
                                <ul className="nav nav-pills" role="tablist">
                                    <li className="nav-item cen-menu-active"
                                        hidden={permissionsData?.find((el) => ["custom-epay", "custom-peiraios", "custom-daras", "custom-employee", "custom-cardlink"].includes(el.permissionName))}>
                                        {renderNavItem("Start")}
                                    </li>
                                    {checkPermissionMasterParentStartingTree("products", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Products")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("sales", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Sales")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("buys", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Buys")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("clients", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Clients")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("suppliers", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Suppliers")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("cash", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Cash")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("fixedassets", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("FixedAssets")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("accounting", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Accounting")}
                                        </li>
                                    )}
                                    {(checkPermissionMasterParentStartingTree("payroll", permissionsData) === true && !companyDetails?.hidePayroll) && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Payroll")}
                                        </li>
                                    )}
                                    {(checkPermissionMasterParentStartingTree("prescription", permissionsData) === true && !companyDetails?.hidePrescription) && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Prescription")}
                                        </li>
                                    )}
                                    {checkPermissionMasterParentStartingTree("settings", permissionsData) === true && (
                                        <li className="nav-item cen-menu-active">
                                            {renderNavItem("Settings")}
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        {/* ___________________PROFILE_LINKS_____________ */}
                        <ul className="navbar-nav navbar-nav-right profileLinksMain">
                            <li className="nav-item nav-profile dropdown" style={{paddingLeft: "0px"}}>
                                <a
                                    className="nav-link dropdown-toggle"
                                    id="profileDropdown"
                                    href="/"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <div className="nav-profile-img">
                                        <img
                                            src={currentUser?.avatar ? currentUser?.avatar : "assets/images/faces/face16.jpg"}
                                            alt="userAvatar"
                                        />
                                        <span className="availability-status online"></span>
                                    </div>
                                    <div className={"ml-2"}>
                                        <IoIosArrowDown size={20} />
                                    </div>
                                </a>
                                <div className="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
                                    <div style={{textAlign: "center", fontSize: "14px", fontWeight: "600"}} className={"border-bottom p-1"}>
                                        {currentUser?.lastName || ""} {currentUser?.firstName || ""}
                                    </div>
                                    <div onClick={() => handleOpenUserManagement()} className="dropdown-item">
                                        Ρυθμίσεις χρήστη
                                    </div>
                                    {checkPermission("custom-releaseNotes", permissionsData) && (
                                        <>
                                            <div className="dropdown-divider"></div>
                                            <div className="dropdown-item" onClick={() => dispatch(setShowReleaseNotesModal(true))}>
                                                Release Notes
                                            </div>
                                        </>
                                    )}
                                    {(isAdmin || isCompanyCreator) && (
                                        <>
                                            <div className="dropdown-divider"></div>
                                            <div className="dropdown-item" onClick={() => handleOpenManageCompanies()}>
                                                Διαχείρηση Εταιρειών
                                            </div>
                                        </>
                                    )}
                                    <div className="dropdown-divider"></div>
                                    <div onClick={() => dispatch(handleLogOut())} className="dropdown-item">
                                        <i className="mdi mdi-logout mr-1 text-primary"></i> {t('NavBar.signOut')}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            )}
        </div>
    )
}

export default Navbar;
